import { IframeSource } from '../../data-types/initialisation/initialisationInterfaces';
import { STREAMING_SUPPLIER } from '../../data-types/stream/streamEnums';
import { PaymentData } from '../../data-types/wallet/walletInterfaces';
import { ResetState } from './stateTypes';

export type IframeActionType =
  | ResetState
  | SetPaymentIframeDialogSource
  | SetFeedbackIframeSource
  | SetDepositTracking
  | SetRegistrationTracking
  | SetStreamIframeSrc
  | SetStreamIframeEventId
  | SetStreamingSupplier
  | SetStreamBetradarStatus
  | SetIsZendeskOpen;

export const SET_PAYMENT_IFRAME_DIALOG_URL = 'SET_PAYMENT_IFRAME_DIALOG_URL';
export const SET_FEEDBACK_IFRAME_SRC = 'SET_FEEDBACK_IFRAME_SRC';
export const SET_STREAM_IFRAME_SRC = 'SET_STREAM_IFRAME_SRC';
export const SET_STREAM_IFRAME_EVENT_ID = 'SET_STREAM_IFRAME_EVENT_ID';
export const SET_STREAMING_SUPPLIER = 'SET_STREAMING_SUPPLIER';
export const SET_STREAM_BETRADAR_STATUS = 'SET_STREAM_BETRADAR_STATUS';
export const SET_DEPOSIT_TRACKING = 'SET_DEPOSIT_TRACKING';
export const SET_REGISTRATION_TRACKING = 'SET_REGISTRATION_TRACKING';
export const SET_IS_ZENDESK_OPEN = 'SET_IS_ZENDESK_OPEN';

export interface IframeState {
  iframeSource: IframeSource;
  isZendeskOpen: boolean;
}

interface SetPaymentIframeDialogSource {
  type: typeof SET_PAYMENT_IFRAME_DIALOG_URL;
  meta: PaymentData | undefined;
}

interface SetFeedbackIframeSource {
  type: typeof SET_FEEDBACK_IFRAME_SRC;
  meta: string | undefined;
}

interface SetStreamIframeSrc {
  type: typeof SET_STREAM_IFRAME_SRC;
  meta: string | undefined;
}

interface SetStreamIframeEventId {
  type: typeof SET_STREAM_IFRAME_EVENT_ID;
  meta: number | undefined;
}

interface SetStreamingSupplier {
  type: typeof SET_STREAMING_SUPPLIER;
  meta: STREAMING_SUPPLIER | undefined;
}

interface SetStreamBetradarStatus {
  type: typeof SET_STREAM_BETRADAR_STATUS;
  meta: string | undefined;
}

interface SetDepositTracking {
  type: typeof SET_DEPOSIT_TRACKING;
  meta: boolean;
}

interface SetRegistrationTracking {
  type: typeof SET_REGISTRATION_TRACKING;
  meta: boolean;
}

interface SetIsZendeskOpen {
  type: typeof SET_IS_ZENDESK_OPEN;
  meta: boolean;
}
